var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "files-page" },
    [
      _vm.fieldsLoading
        ? _c("div", { staticClass: "files-browser" }, [
            _c(
              "div",
              { staticClass: "files-toolbar" },
              [
                _c("v-skeleton-loader", {
                  staticClass: "files-skeleton-search",
                  attrs: { type: "text" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "files-grid files-grid--skeleton" },
              _vm._l(8, function (n) {
                return _c("v-skeleton-loader", {
                  key: n,
                  staticClass: "files-skeleton-tile",
                  attrs: { type: "image" },
                })
              }),
              1
            ),
          ])
        : [
            !_vm.activeHtmlLink
              ? _c(
                  "div",
                  { staticClass: "files-browser" },
                  [
                    _c(
                      "div",
                      { staticClass: "files-toolbar" },
                      [
                        _c("v-text-field", {
                          staticClass: "files-search",
                          attrs: {
                            placeholder: _vm.$t("message.common.search"),
                            "prepend-inner-icon": "mdi-magnify",
                            clearable: "",
                            "hide-details": "",
                            "single-line": "",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            input: _vm.onSearchInput,
                            "click:clear": _vm.clearSearch,
                          },
                          model: {
                            value: _vm.fileSearchTerm,
                            callback: function ($$v) {
                              _vm.fileSearchTerm = $$v
                            },
                            expression: "fileSearchTerm",
                          },
                        }),
                        _c(
                          "v-btn-toggle",
                          {
                            staticClass: "files-view-toggle",
                            attrs: {
                              value: _vm.viewMode,
                              mandatory: "",
                              dense: "",
                            },
                            on: { change: _vm.setViewMode },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  value: "grid",
                                  small: "",
                                  icon: "",
                                  title: _vm.$t("message.common.gridView"),
                                  "aria-label": _vm.$t(
                                    "message.common.gridView"
                                  ),
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-view-grid"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  value: "list",
                                  small: "",
                                  icon: "",
                                  title: _vm.$t("message.common.listView"),
                                  "aria-label": _vm.$t(
                                    "message.common.listView"
                                  ),
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-format-list-bulleted"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.isSearching
                      ? _c(
                          "div",
                          { staticClass: "files-crumbs" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "files-up",
                                attrs: {
                                  icon: "",
                                  small: "",
                                  disabled: _vm.breadCrumbItems.length <= 2,
                                  title: _vm.$t("message.common.back"),
                                  "aria-label": _vm.$t("message.common.back"),
                                },
                                on: { click: _vm.goUp },
                              },
                              [_c("v-icon", [_vm._v("mdi-arrow-left")])],
                              1
                            ),
                            _c(
                              "div",
                              {
                                ref: "crumbScroll",
                                staticClass: "files-crumb-scroll",
                              },
                              [
                                _vm._l(
                                  _vm.breadCrumbItems,
                                  function (item, index) {
                                    return [
                                      index
                                        ? _c(
                                            "v-icon",
                                            {
                                              key: "sep_" + index,
                                              staticClass: "files-crumb-sep",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v("mdi-chevron-right")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "button",
                                        {
                                          key: "crumb_" + item.id,
                                          staticClass: "files-crumb",
                                          class: {
                                            "files-crumb--current":
                                              index ===
                                              _vm.breadCrumbItems.length - 1,
                                          },
                                          attrs: {
                                            type: "button",
                                            disabled:
                                              index ===
                                              _vm.breadCrumbItems.length - 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.navigateToItem(item)
                                            },
                                          },
                                        },
                                        [
                                          item.isHome
                                            ? _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "files-crumb-home",
                                                  attrs: { small: "" },
                                                },
                                                [_vm._v("mdi-home-outline")]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.crumbLabel(item))
                                                ),
                                              ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "files-crumbs files-crumbs--search" },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-magnify")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "files-crumb files-crumb--current",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("message.common.searchResults"))
                                ),
                              ]
                            ),
                            !_vm.searchLoading
                              ? _c("span", { staticClass: "files-count" }, [
                                  _vm._v(_vm._s(_vm.listOfSearchResult.length)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                    _c("v-progress-linear", {
                      staticClass: "files-progress",
                      attrs: {
                        indeterminate: "",
                        height: "2",
                        active: _vm.loading || _vm.searchLoading,
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "files-content",
                        class: {
                          "files-content--stale":
                            _vm.loading || _vm.searchLoading,
                        },
                      },
                      [
                        _vm.visibleFolders.length || _vm.visibleFiles.length
                          ? [
                              _vm.viewMode === "grid"
                                ? [
                                    _vm.visibleFolders.length
                                      ? _c(
                                          "section",
                                          { staticClass: "files-section" },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "files-section-title",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.common.folders"
                                                    )
                                                  ) + " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "files-count",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.visibleFolders
                                                          .length
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "files-grid" },
                                              _vm._l(
                                                _vm.visibleFolders,
                                                function (doc) {
                                                  return _c(
                                                    "button",
                                                    {
                                                      key: "folder_" + doc.id,
                                                      staticClass:
                                                        "files-tile files-tile--folder",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openDocument(
                                                            doc
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "files-tile-icon",
                                                          style:
                                                            _vm.iconBadgeStyle(
                                                              doc
                                                            ),
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm.iconOf(
                                                                    doc
                                                                  ).color,
                                                                size: "30",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.iconOf(
                                                                    doc
                                                                  ).icon
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "files-tile-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nameOf(doc)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "files-tile-meta",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.isSearching &&
                                                                doc.parent_folder_name
                                                                ? doc.parent_folder_name
                                                                : _vm.$t(
                                                                    "message.common.folder"
                                                                  )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.visibleFiles.length
                                      ? _c(
                                          "section",
                                          { staticClass: "files-section" },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "files-section-title",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.common.files"
                                                    )
                                                  ) + " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "files-count",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.visibleFiles.length
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "files-grid" },
                                              _vm._l(
                                                _vm.visibleFiles,
                                                function (doc) {
                                                  return _c(
                                                    "button",
                                                    {
                                                      key: "file_" + doc.id,
                                                      staticClass: "files-tile",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openDocument(
                                                            doc
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "files-tile-icon",
                                                          style:
                                                            _vm.iconBadgeStyle(
                                                              doc
                                                            ),
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm.iconOf(
                                                                    doc
                                                                  ).color,
                                                                size: "30",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.iconOf(
                                                                    doc
                                                                  ).icon
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "files-tile-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.nameOf(doc)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "files-tile-meta",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.metaOf(doc)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _c(
                                    "v-list",
                                    {
                                      staticClass: "files-list pa-0",
                                      attrs: { dense: "" },
                                    },
                                    _vm._l(
                                      _vm.visibleFolders.concat(
                                        _vm.visibleFiles
                                      ),
                                      function (doc) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: "row_" + doc.id,
                                            staticClass: "files-row px-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openDocument(doc)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "files-row-icon my-1 mr-3",
                                                style: _vm.iconBadgeStyle(doc),
                                                attrs: { tile: "", size: "38" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color:
                                                        _vm.iconOf(doc).color,
                                                      size: "24",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iconOf(doc).icon
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "py-2" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "files-row-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.nameOf(doc))
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-list-item-subtitle",
                                                  {
                                                    staticClass:
                                                      "files-row-meta",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.metaOf(doc))
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-action",
                                              { staticClass: "my-0" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass:
                                                      "files-row-chevron",
                                                    attrs: { small: "" },
                                                  },
                                                  [_vm._v("mdi-chevron-right")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                            ]
                          : !_vm.loading && !_vm.searchLoading
                          ? _c(
                              "div",
                              { staticClass: "files-empty" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "files-empty-icon",
                                    attrs: { size: "56" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isSearching
                                          ? "mdi-file-search-outline"
                                          : "mdi-folder-open-outline"
                                      )
                                    ),
                                  ]
                                ),
                                _c("p", { staticClass: "files-empty-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isSearching
                                        ? _vm.$t("message.common.noResults")
                                        : _vm.$t("message.common.emptyFolder")
                                    )
                                  ),
                                ]),
                                !_vm.isSearching
                                  ? _c(
                                      "p",
                                      { staticClass: "files-empty-hint" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.common.emptyFolderHint"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _c(
                  "v-card",
                  { staticClass: "files-viewer", attrs: { flat: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "files-viewer-head" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              title: _vm.$t("message.common.back"),
                              "aria-label": _vm.$t("message.common.back"),
                            },
                            on: { click: _vm.closeViewer },
                          },
                          [_c("v-icon", [_vm._v("mdi-arrow-left")])],
                          1
                        ),
                        _vm.activeDocument
                          ? _c(
                              "span",
                              {
                                staticClass: "files-viewer-icon",
                                style: _vm.iconBadgeStyle(_vm.activeDocument),
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: _vm.iconOf(_vm.activeDocument)
                                        .color,
                                      size: "20",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.iconOf(_vm.activeDocument).icon
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "files-viewer-title text-truncate",
                            attrs: { title: _vm.activeHtmlTitle },
                          },
                          [_vm._v(_vm._s(_vm.activeHtmlTitle))]
                        ),
                        _vm.activeDocuments.length > 1
                          ? _c(
                              "span",
                              { staticClass: "files-viewer-nav" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      disabled: !_vm.previous_document,
                                      title: _vm.$t(
                                        "message.common.previousDocument"
                                      ),
                                      "aria-label": _vm.$t(
                                        "message.common.previousDocument"
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadHtmlFile(
                                          _vm.previous_document
                                        )
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticClass: "files-viewer-counter" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.viewerIndex + 1) +
                                        " / " +
                                        _vm._s(_vm.activeDocuments.length)
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      disabled: !_vm.next_document,
                                      title: _vm.$t(
                                        "message.common.nextDocument"
                                      ),
                                      "aria-label": _vm.$t(
                                        "message.common.nextDocument"
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadHtmlFile(
                                          _vm.next_document
                                        )
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        ref: "pdfViewport",
                        staticClass: "main_pdf_view",
                        class: { "main_pdf_view--fit": _vm.fitToScreen },
                      },
                      [
                        _c(
                          "v-row",
                          { staticClass: "mx-0", style: _vm.rowSizingStyle },
                          [
                            _vm.iframeSrcLoading && !_vm.showPdfPreviewDialog
                              ? _c("v-progress-linear", {
                                  attrs: {
                                    indeterminate: "",
                                    color: "primary",
                                  },
                                })
                              : _vm._e(),
                            _vm.showPdfPreviewDialog
                              ? _c(
                                  "v-responsive",
                                  { attrs: { "aspect-ratio": 16 / 9 } },
                                  [
                                    _c("pdf-viewer", {
                                      key: _vm.activeHtmlLink,
                                      attrs: {
                                        fileUrl: _vm.activeHtmlLink,
                                        renderWidth: _vm.pdfRenderWidth,
                                      },
                                      on: { error: _vm.onDocumentError },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-responsive",
                                  {
                                    style:
                                      "visibility: " +
                                      (_vm.iframeSrcLoading ? "hidden" : ""),
                                    attrs: { "aspect-ratio": 16 / 9 },
                                  },
                                  [
                                    _c("iframe", {
                                      staticClass: "files-html",
                                      style: _vm.isScaled
                                        ? _vm.fitTransformStyle
                                        : null,
                                      attrs: {
                                        width: _vm.isScaled
                                          ? _vm.fitBaseWidth + "px"
                                          : "100%",
                                        src: _vm.activeHtmlLink,
                                      },
                                      on: {
                                        load: function ($event) {
                                          _vm.iframeSrcLoading = false
                                        },
                                      },
                                    }),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "button__box" }, [
                      _c(
                        "button",
                        {
                          attrs: {
                            title: _vm.$t("message.common.zoomIn"),
                            disabled: !_vm.canZoomIn,
                          },
                          on: { click: _vm.zoomIn },
                        },
                        [_vm._v("+")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button__box-fit",
                          attrs: {
                            title: _vm.fitToScreen
                              ? _vm.$t("message.common.actualSize")
                              : _vm.$t("message.common.fitToScreen"),
                          },
                          on: { click: _vm.toggleFitToScreen },
                        },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.fitToScreen
                                  ? "mdi-fullscreen-exit"
                                  : "mdi-fullscreen"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "button",
                        {
                          attrs: {
                            title: _vm.$t("message.common.zoomOut"),
                            disabled: !_vm.canZoomOut,
                          },
                          on: { click: _vm.zoomOut },
                        },
                        [_vm._v("-")]
                      ),
                    ]),
                  ]
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }